/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindMaterialTypesQueryResponse,
  FindMaterialTypesQueryParams,
} from "../types/FindMaterialTypes.ts"

export const findMaterialTypesQueryKey = (
  params?: FindMaterialTypesQueryParams
) => [{ url: "/v1/material-type" }, ...(params ? [params] : [])] as const

export type FindMaterialTypesQueryKey = ReturnType<
  typeof findMaterialTypesQueryKey
>

/**
 * {@link /v1/material-type}
 */
export async function findMaterialTypes(
  params?: FindMaterialTypesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindMaterialTypesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/material-type`, params, ...requestConfig })
  return res
}

export function findMaterialTypesQueryOptions(
  params?: FindMaterialTypesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findMaterialTypesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindMaterialTypesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindMaterialTypesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findMaterialTypes(params, config)
    },
  })
}

/**
 * {@link /v1/material-type}
 */
export function useFindMaterialTypes<
  TData = ResponseConfig<FindMaterialTypesQueryResponse>,
  TQueryData = ResponseConfig<FindMaterialTypesQueryResponse>,
  TQueryKey extends QueryKey = FindMaterialTypesQueryKey,
>(
  params?: FindMaterialTypesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindMaterialTypesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findMaterialTypesQueryKey(params)

  const query = useQuery(
    {
      ...findMaterialTypesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
